import React from "react";
import clsx from "clsx";
import ActionButton from "../inputs/ActionButton";
import styles from "./LocalNav.module.scss";
import { _link, mainPageAnchors } from "../../common/utilities";
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
import { generatePageURI, pagePaths } from "../../common/utilities";
import LinkScroll from "./LinkScroll";

function LocalNavItem(props) {
  const { data, anchor, onClick } = props;
  const { t } = useTranslation();

  return (
    <div className={styles.nav__link}>
      {anchor ? (
        <LinkScroll 
          to={data.id} 
          className={styles.cursor}
          onClick={onClick}
          offset={-40}
        >
          <i className={clsx(styles.icon, `icon-${data.icon}`)} />
          <span>{t(data.name)}</span>
        </LinkScroll>
      ) : (
        <Link to={data.URL}>
          <i className={clsx(styles.icon, `icon-${data.icon}`)} />
          <span>{t(data.name)}</span>
        </Link>
      )}
    </div>
  );
}

export default function LocalNav(props) {
  const {
    mobile,
    premiumLogged,
    loggedIn,
    creator,
    mainPage,
    onAnchorClick
  } = props;
  const { t } = useTranslation();

  const subPages = [
    {
      name: t("Ranked Statistics History"),
      URL: generatePageURI(pagePaths.RANKED_STATS),
      icon: "icon-ranked"
    },
    {
      name: t("Achievements"),
      URL: generatePageURI(pagePaths.ACHIEVEMENTS),
      icon: "icon-achievement"
    },
    {
      name: t("Ribbons"),
      URL: generatePageURI(pagePaths.RIBBONS),
      icon: "icon-ribbons"
    },
    {
      name: t("Inventory"),
      URL: generatePageURI(pagePaths.INVENTORY),
      icon: "icon-inventory"
    },
    {
      name: t("Collections"),
      URL: generatePageURI(pagePaths.COLLECTONS),
      icon: "icon-collection"
    }
  ];

  const anchors = Object.values(mainPageAnchors)
    .filter(element => {
      return element.name == mainPageAnchors.CONTENT_CREATOR.name
        ? creator
        : true;
    });

  return (
    <div className={styles.nav__dropdown}>
      {premiumLogged && mobile && (
        <ActionButton 
          style={{ marginBottom: 24 }}
          linkTo={generatePageURI(pagePaths.PROFILE_MANAGER)}  
        >
          {t('Edit My Profile')}
        </ActionButton>
      )}
      <span>{t('Sub-Pages')}</span>
      {subPages.map(item => (
        <LocalNavItem data={item} key={item.name}/>
      ))}
      {mobile && mainPage && (
        <>
          <span className={styles.main_page_anchors_heading}>
            {t('Main Page Anchors')}
          </span>
          {anchors.map(item => (
            <LocalNavItem 
              data={item} 
              anchor 
              onClick={onAnchorClick}
              key={item.name}
            />
          ))}
        </>
        //cheap way of putting link in button - need to style link
      )}
      {!premiumLogged && (
        <ActionButton
          variant="subtle"
          // onClick={() => {
          //   console.log('sdfsd')
          //   return <Redirect to={'/great'} />;
          // }}
          classes={{ root: styles.report_btn }}
          href={_link["submit_ticket_url"]}
        >
          {t('Report User')}
        </ActionButton>
      )}
    </div>
  );
}
